import React from 'react';
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';

import Button from '../../components/Button';
import HeaderLogo from '../../components/HeaderLogo'

function Home() {
  return (
    <div className="page-container">
        <div className="flex row mainpadding">
            <Link to="/" className="back-button">
                <div>{'< กลับ'}</div>
            </Link>
            <div className="bread-crump">
                <span className="h5 grey-text semibold">
                    <span className="green-text">รายละเอียด</span> / เลือกบริการ / สรุปข้อมูล
                </span>
            </div>
        </div>
        <div style={{paddingTop: '20%'}}>
            <div className="h1 semibold">คุณต้องการ<br/>ปูกระเบื้องบริเวณใด?</div>
            <div className="h6"><br/></div>
            <div className="flex row">
                <Link to={'/tiles/notiles/product/floor'} className="home-card-link-wrapper">
                    <div className="home-card-wrapper">
                        <div className="home-card-container ">
                            <div id="floor-tile" className="home-card-image-wrapper">
                                {/* <img className="fit-width-img" src="/asset/floor tile choice.jpg"/> */}
                            </div>
                            <div className="h3 semibold">บริเวณพื้น</div>
                            {/* <div className="h6 semibold">เริ่มต้นเพียง <span className="h3 bold">฿5,400</span></div> */}
                            <Button 
                            fullWidth 
                            text={'เลือก'} 
                            style={{marginTop: '15px', marginBottom: '10px'}} 
                            />
                        </div>
                    </div>
                </Link>
                <Link to={'/tiles/notiles/product/wall'} className="home-card-link-wrapper">
                    <div className="home-card-wrapper">
                        <div className="home-card-container">
                            <div id="wall-tile" className="home-card-image-wrapper">
                                {/* <img className="fit-width-img" src="/asset/notiles.png"/> */}
                            </div>
                            <div className="h3 semibold">บริเวณผนัง</div>
                            {/* <div className="h6 semibold">เริ่มต้นเพียง <span className="h3 bold">฿9,200</span></div> */}
                            <Button 
                            fullWidth 
                            text={'เลือก'} 
                            style={{marginTop: '15px', marginBottom: '10px'}} 
                            />
                        </div>
                    </div>
                </Link>
            </div>
        </div>
    </div>
  );
}

export default Home;
